/**
 * Web Style Import
 *
 */

import './style/dnb-autocomplete.scss'
